module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"way":"Путь"},"en":{"way":"Way"}}')
  delete Component.options._Ctor
}
